export const grnHeaders = [
  { id: 1, column: 'shortage_count', name: 'shortage', tlabel: 'INDENT_SHORTAGES', charge: 'shortage_charge', unit: 'shortage_unit', class: 'w100', label: 'SHORTAGES', canExceed: false, width: 105 },
  { id: 2, column: 'damage_count', name: 'damage', tlabel: 'INDENT_DAMAGES', charge: 'damage_charge', unit: 'damage_unit', class: 'w100', label: 'DAMAGES', canExceed: false, width: 75 },
  { id: 3, column: 'carton_damage_count', name: 'carton_damage', tlabel: 'INDENT_CARTON_DAMAGES', charge: 'carton_damage_charge', unit: 'carton_damage_unit', class: 'w100', label: 'CARTON DAMAGES', canExceed: false, width: 75 },
  { id: 4, column: 'leakage_count', name: 'leakage', class: 'w100', tlabel: 'LEAKAGES', label: 'LEAKAGES', canExceed: false, width: 75, readOnly: true, feature: 'show_grn_excess', permission: 'edit_grn_excess' }, // TODO for berger they refering this fields as actual Qty received in UI only we didn't do any calculation
  { id: 5, column: 'accepted_quantity', name: 'accepted_quantity', charge: 'accepted_quantity', class: 'w100', tlabel: 'ACCEPTED_QUANTITY', canExceed: false, width: 75, readOnly: true, feature: 'show_grn_accepted_qty' },
  { id: 6, column: 'excess_count', name: 'excess', class: 'w100', tlabel: 'INDENT_EXCESS', label: 'EXCESS', canExceed: true, width: 75, readOnly: true, feature: 'show_grn_excess', permission: 'edit_grn_excess' },
  { id: 7, column: 'actual_qty_received', name: 'actual_quantity', class: 'w100', tlabel: 'INDENT_ACTUAL_QUANTITY', label: 'ACTUAL QUANTITY', canExceed: true, width: 75, readOnly: true, feature: 'show_grn_excess' },
  { id: 8, column: 'transporter_debit', name: 'transporter_debit', charge: 'transporter_debit', class: 'w100', tlabel: 'TRANSPORTER_DEBIT_CHARGE', canExceed: false, feature: 'show_grn_custom_fields' },
  { id: 9, column: 'type_of_damage', name: 'type_of_damage', charge: 'type_of_damage', class: 'w100', tlabel: 'TYPE_OF_DAMAGE', canExceed: false, feature: 'show_grn_custom_fields' },
  { id: 10, column: 'percentage_damage', name: 'percentage_damage', charge: 'percentage_damage', class: 'w100', tlabel: 'PERCENTAGE_OF_DAMAGE', canExceed: false, feature: 'show_grn_custom_fields' },
];

export const units = {
  KG: 'kg',
  MT: 'MT',
  PIECES: 'pieces',
  CASES: 'cases',
  QUANTITY_UNIT: 'QUANTITY UNIT',
  PCE_TO_QUANTITY_UNIT: 'PCE TO QUANTITY UNIT',
};

export const quantityUnits = {
  'c/s': 'cases',
  's/o': 'cases',
  cs: 'cases',
  box: 'cases',
  boxes: 'cases',
  pkg: 'cases',
  pkgs: 'cases',
  cases: 'cases',
  case: 'cases',
  nos: 'cases',
  pce: 'pieces',
  no: 'pieces',
  pcs: 'pieces',
  bags: 'cases',
  each: 'pieces',
  kg: 'kg',
  ea: 'pieces',
  pieces: 'pieces',
  kar: 'cases',
  ctn: 'cases',
  st: 'cases',
  it: 'pieces',
  pc: 'pieces',
  PC: 'pieces',
  CV: 'cases',
  cv: 'cases',
  PAC: 'pieces',
  pac: 'pieces',
};

export default grnHeaders;
